import { MenuItem } from './menu.model';
import { Company } from '@shared/enums/company';
import Roles from '@shared/constants/roles';
import System from '@shared/constants/system';


export const DEALER_MENU: MenuItem[] = [
  {
    label: 'MENUITEMS.TICKETS.TEXT',
    icon: 'fa-ticket',
    link: '/tickets',
    componentId: 'tickets',
    permits: [
      { company: Company.Sea, roles: Roles.admin },
      { company: Company.Sea, roles: Roles.dealerSupport },
      { company: Company.Seca, roles: Roles.secaTicket },
      { company: Company.SeaIm, roles: Roles.seaImTicket },
    ],
  }, {
    label: 'MENUITEMS.DEALERS.TEXT',
    icon: 'fa-buildings',
    link: '/dealers',
    componentId: 'dealers',
    permits: [
      { company: Company.Sea, roles: Roles.bizAdmin },
      { company: Company.Sea, roles: Roles.adminSelect },
      { company: Company.Sea, roles: Roles.dealerSupport },
      { company: Company.Seca, roles: Roles.secaDealer },
      { company: Company.SeaIm, roles: Roles.seaImDealer },
    ]
  }, {
    label: 'MENUITEMS.USERS.TEXT',
    icon: 'fa-user-check',
    link: '/users',
    componentId: 'users',
    permits: [
      { company: Company.Sea, roles: Roles.dealerSupport },
      { company: Company.Seca, roles: Roles.admin },
      { company: Company.Seca, roles: Roles.dealerSupervisor },
      { company: Company.SeaIm, roles: Roles.admin },
      { company: Company.SeaIm, roles: Roles.dealer },
      { company: Company.Sea, roles: Roles.cdStore },
      { company: Company.Sea, roles: Roles.ussiAdmin },
      { company: Company.Sea, roles: Roles.adminSelect },
    ]
  }, {
    label: 'MENUITEMS.CONCEALED-DAMAGE.TEXT',
    icon: 'fa-display-slash',
    link: '/concealed-damage',
    componentId: 'concealedDamage',
    permits: [
      { company: Company.Sea, roles: Roles.cdSupport },
    ]
  }, {
    label: 'MENUITEMS.SUMMARY.TEXT',
    icon: 'fa-line-columns',
    link: '/summary',
    componentId: 'summary',
    isLayout: true,
    permits: [
      { company: Company.Sea, roles: Roles.summaryView },
      { company: Company.Seca, roles: Roles.secaSummary },
      { company: Company.SeaIm, roles: Roles.seaImSummary },
    ]
  }, {
    label: 'MENUITEMS.PAYMENTS.TEXT',
    icon: 'fa-credit-card',
    link: '/payments',
    componentId: 'payments',
    permits: [
      { company: Company.SeaIm, roles: Roles.seaImDealer },
      { company: Company.SeaIm, roles: Roles.admin },
    ]
  }, {
    label: 'MENUITEMS.PURCAHSE-PLACE.TEXT',
    icon: 'fa-solid fa-shop',
    link: '/purchase-place',
    componentId: 'purchasePlace',
    permits: [
      { company: Company.Seca, roles: Roles.admin },
    ]
  }
];

export const B2B_MENU: MenuItem[] = [
  {
    label: 'MENUITEMS.DASHBOARD-TICKET.TEXT',
    icon: 'fa-map-location',
    link: '/dashboards/ticket',
    componentId: 'dashboard-ticket',
    permits: [
      { company: Company.Sea, roles: Roles.b2bUser },
    ]
  },
  {
    label: 'MENUITEMS.CASE.TEXT',
    icon: 'fa-display-slash',
    link: '/cases',
    componentId: 'cases',
    permits: [
      { company: Company.Sea, roles: Roles.b2bUser },
    ]
  },
  {
    label: 'MENUITEMS.TICKETS.TEXT',
    // icon: 'uil-chart',
    icon: 'fa-ticket',
    link: '/tickets',
    componentId: 'tickets',
    permits: [
      { company: Company.Sea, roles: Roles.b2bAdminAndCustomer },
    ],
  },
  {
    label: 'MENUITEMS.RSM.TEXT',
    // icon: 'uil-chart',
    icon: 'fa-exchange',
    link: '/rsm-escalation',
    componentId: 'rsm',
    permits: [
      { company: Company.Sea, roles: Roles.b2bRsm },
    ],
  },
  {
    label: 'MENUITEMS.BP.TEXT',
    icon: 'fa-buildings',
    link: '/bps',
    componentId: 'bps',
    permits: [
      { company: Company.Sea, roles: Roles.b2bAdmin },
    ]
  },
  {
    label: 'MENUITEMS.USERS.TEXT',
    icon: 'fa-user-check',
    link: '/users',
    componentId: 'users',
    permits: [
      { company: Company.Sea, roles: Roles.b2bUserAdmin },
    ]
  },
  {
    label: 'MENUITEMS.ZIP-CODE.TEXT',
    icon: 'fa-map',
    link: '/zip-code',
    componentId: 'zip-code',
    permits: [
      { company: Company.Sea, roles: Roles.b2bAdminOnly },
      { company: Company.Sea, roles: Roles.b2bPartnerAdmin },
    ]
  },
  {
    label: 'MENUITEMS.EXTEND-SERIAL.TEXT',
    icon: 'fa-file-invoice',
    link: '/extend-serial',
    componentId: 'extend-serial',
    permits: [
      { company: Company.Sea, roles: Roles.b2bAdminOnly },
      { company: Company.Sea, roles: Roles.b2bPartnerAdmin },
    ]
  },
  {
    label: 'MENUITEMS.INQUIRY.TEXT',
    icon: 'fa-comments',
    link: '/escalation',
    componentId: 'escalation',
    permits: [
      { company: Company.Sea, roles: Roles.b2bAdminAndCustomer },
      { company: Company.Sea, roles: Roles.b2bPartnerRsm },
    ],
  },
];

let MENU = [];

if (System.isDealerSystem()) {
  MENU = DEALER_MENU;
} else {
  MENU = B2B_MENU;
}

export { MENU };
